export type ZoningScore = {
  zoneCount: number
  varianceExplained: number
  reassignedShare: number
}

export const recommendZoneCount = ({
  scores,
  minGain,
  maxReassigned
}: {
  scores: ZoningScore[]
  minGain: number
  maxReassigned: number
}) => {
  const usable = scores
    .filter(({ reassignedShare }) => reassignedShare <= maxReassigned)
    .toSorted((a, b) => a.zoneCount - b.zoneCount)

  const firstWithoutGain = usable.findIndex(
    (score, i) => i > 0 && score.varianceExplained - usable[i - 1].varianceExplained < minGain
  )

  const recommended = firstWithoutGain === -1 ? usable.at(-1) : usable[firstWithoutGain - 1]
  return recommended?.zoneCount
}
